module.exports = new __parcel__URL__("icon-2.f0864db5.svg").toString();